import qs from 'qs';

import { SubscribePlan } from '@zep/types';

import { OnetimePeriod, PlanTemplateType, SubscriptionPeriod } from '../types';

/**
 * 주어진 파라미터를 바탕으로 결제 페이지로 이동할 쿼리 문자열을 생성합니다.
 * 이 함수는 쿼리 문자열만 생성하며, 실제로 페이지 이동은 처리하지 않습니다.
 * @param params
 *  - planType: 결제할 요금제 타입
 *  - planTemplateType: 결제할 요금제 템플릿 타입
 *  - spaceHashId: 결제할 공간의 해시 아이디
 *  - maxCcu: 최대 CCU
 *    - 해당 값은 필수가 아닙니다.
 *    - 해당 값이 주어지지 않으면 플랜별 최소값으로 설정됩니다.
 *    - Basic: 20, Pro: 10
 *  - onetimeStartDate: 일시납 시작일(YYYY-MM-DD)
 *    - 해당 값은 필수가 아닙니다. 없으면 결제 화면이 오늘로 시작합니다.
 *    - 견적서의 `결제 바로가기` 가 견적과 같은 시작일로 열기 위해 사용합니다.
 */
export const generatePaymentQuery = (params: Params) => {
  return qs.stringify({
    ...params,
    // 괄호가 없으면 `(maxCcu ?? planType === 'basic') ? 20 : 10` 으로 읽혀
    // 넘긴 인원이 전부 20 이 된다. 기존 호출부는 maxCcu 를 안 넘겨 드러나지 않았다.
    maxCcu: params.maxCcu ?? (params.planType === 'basic' ? 20 : 10),
  });
};

type BaseParams = {
  planType: Omit<SubscribePlan, 'free'>;
  planTemplateType: PlanTemplateType;
  spaceHashId: string;
  maxCcu?: number;
};

type SubscriptionParams = BaseParams & {
  planTemplateType:
    | PlanTemplateType.PRODUCT_SUBSCRIPTION
    | PlanTemplateType.CUSTOM_SUBSCRIPTION;
  subscriptionPeriod: SubscriptionPeriod;
  onetimePeriod?: never;
};

type OnetimeParams = BaseParams & {
  planTemplateType: PlanTemplateType.PRODUCT_ONETIME;
  onetimePeriod: OnetimePeriod;
  /** YYYY-MM-DD. 정기결제에는 없는 값이라 일시납 쪽에만 둔다. */
  onetimeStartDate?: string;
  subscriptionPeriod?: never;
};

type Params = SubscriptionParams | OnetimeParams;
